import { ReactNode } from "react";
import styles from "./Tab.module.css";
import { NavLink } from "../Typography";
import cx from "classnames";

type TabProps = {
  label?: string;
  data?: {
    url: string;
    text: string;
    isSelected?: boolean;
  }[];
};

export default function Tab({ label = "", data }: TabProps): ReactNode {
  return (
    data && (
      <div className={styles.tabContainer}>
        {label && <span className={styles.tabLabel}>{label}</span>}

        <div className={styles.tabGroup}>
          {data.map((list, i) => {
            return (
              <NavLink
                key={i}
                href={list.url}
                customClassName={cx(
                  styles.tabGroupElement,
                  list.isSelected && styles.tabSelected,
                )}
              >
                {list.text}
              </NavLink>
            );
          })}
        </div>
      </div>
    )
  );
}
